import { makeStyles } from "@mui/styles";
import { getSharedStyles } from "../../../shared/shared-styles";

export const useStyles = makeStyles((theme) => ({
  "@global": {
    ".k-popup": {
      zIndex: "99999 !important",
    },
    ".k-popup.k-popup-transparent": {
      zIndex: "99999 !important",
    },
    ".k-calendar": {
      zIndex: "99999 !important",
    },
    ".k-animation-container": {
      zIndex: "99999 !important",
    },
  },
  ...getSharedStyles(theme),
}));
